<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="model.pkid ? '编辑' : '新建'"
        width="600px"
        @close="$reset('form')"
    >
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="model"
          class="form"
          label-width="80px">
        <el-form-item label="设备绑定类型" prop="deviceType">
          <el-input v-model="model.deviceType" placeholder="设备绑定类型"/>
        </el-form-item>
        <el-form-item label="设备名称" prop="deviceName">
          <el-input v-model="model.deviceName" placeholder="请输入设备名称"/>
        </el-form-item>
        <el-form-item label="MAC地址" prop="deviceMAC">
          <el-input v-model="model.deviceMAC" placeholder="请输入MAC地址"/>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model.trim="model.explain" placeholder="请输入描述" clearable/>
        </el-form-item>
        <el-form-item label="IP地址" prop="deviceIPAddress">
          <el-input v-model="model.deviceIPAddress" placeholder="请输入IP地址"/>
        </el-form-item>
        <el-form-item label="标准工序码" prop="standCode">
          <el-select v-model="model.standCode" placeholder="请选择标准工序码">
            <el-option
                v-for="item in routeCodeList"
                :key="item.ktsch"
                :value="item.ktsch"
                :label="item.ltxa1"
                @change="dataChange"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
      </span>
    </el-dialog>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="deviceBindings"
        @reset="resetHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-button type="primary" @click="refreshCache()">刷新缓存</el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
            <!--            <el-form-item label="订单编号">-->
            <!--              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入订单编号" clearable/>-->
            <!--            </el-form-item>-->
            <el-form-item label="设备绑定类型">
              <el-select v-model="filter.deviceType" clearable placeholder="请选择设备绑定类型">
                <el-option label="全部" value=""/>
                <el-option label="PC测试" value="PC测试"/>
                <el-option label="PC测试台" value="PC测试台"/>
                <el-option label="PC客户端" value="PC客户端"/>
                <el-option label="测试工装" value="测试工装"/>
                <el-option label="三色灯声光报警" value="三色灯声光报警"/>
                <el-option label="扫码终端" value="扫码终端"/>
                <el-option label="显示终端" value="显示终端"/>
              </el-select>
            </el-form-item>
            <el-form-item label="设备名称">
              <el-input v-model.trim="filter.deviceName" placeholder="请输入设备名称" clearable/>
            </el-form-item>
            <el-form-item label="MAC地址">
              <el-input v-model.trim="filter.deviceMac" placeholder="请输入MAC地址" clearable/>
            </el-form-item>
            <el-form-item label="IP地址">
              <el-input v-model.trim="filter.deviceIpAddress" placeholder="请输入IP地址" clearable/>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model.trim="filter.explain" placeholder="请输入描述" clearable/>
            </el-form-item>
            <el-form-item label="标准工序码">
              <el-input v-model.trim="filter.standCode" placeholder="请输入标准工序码" clearable/>
            </el-form-item>
            <el-form-item label="工序描述">
              <el-input v-model.trim="filter.procedureName" placeholder="请输入工序描述" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
  </div>
</template>

<script>

  import ViewTable from "@/components/ViewTable";

  export default {
    name: "DeviceBindingList",
    components: {ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(23),
          editAuth: this.$auth(24),
          // delAuth: this.$auth(9),
          subAuth: this.$auth(24),
        },
        filter: {
          deviceName: "",
          deviceMac: "",
          deviceType: "",
          deviceIpAddress: "",
          explain: "",
          standCode: "",
          procedureName: "",
        },
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        columnsProperty: [
          {
            tooltip: true,
            key: "salesOrderNO",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.salesOrderEdit.open(params.row, 0, true);
                    },
                  },
                },
                params.row.salesOrderNO,
              );
            },
          },
          {
            key: "action",
            width: 100,
            slot: "action",
            fixed: "right",
          },
        ],
        model: {},
        routeCodeList: [],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        if (row) {
          this.model=row;
        }
        this.$http.get("basic", "sapBaseRoutes/getAllRouteCode")
          .then(resp => {
            if (resp.success) {
              this.routeCodeList = resp.data;
            }
          });

        this.dialogVisible = true;
      },

      submitHandle() {
        if(this.model.id > 0) {
          this.$http.put("basic", "deviceBindings", this.model)
            .then(resp => {
              if (resp.success) {
                this.$message.success("保存成功");
              }
            }).finally(() => {
              this.dialogVisible = false;
              this.model = {};
              this.loadData();
            });
        }else {
          this.$http.post("basic", "deviceBindings", this.model)
            .then(resp => {
              if (resp.success) {
                this.$message.success("保存成功");
              }
            }).finally(() => {
              this.dialogVisible = false;
              this.model = {};
              this.loadData();
            });
        }

      },

      dataChange() {
        let obj = this.routeCodeList.every(item => item.ktsch === this.model.standCode);
        this.model.procedureName = obj.ltxa1;
      },


      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.demandStatus !== "Y") {
          return false;
        } else {
          return true;
        }
      },

      refreshCache() {
        this.$http.get("basic", "deviceBindings/refreshCache")
          .then((resp) => {
            if (resp.success) {
              this.$message.success("刷新成功");
              this.loadData();
            }
          });
      },

    },
  };
</script>
